<template>
    <div class="app-header">
        <h2>Javascript Keycodes</h2>
    </div>
</template>

<script>
export default {
    name: 'Header'
}
</script>

<style>
.app-header{
    height: 50px;
    line-height: 50px;
    color: #fff;
    background: #2c3e50;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.app-header h2 {
  color: white;
  text-shadow: 2px 2px 4px #fff;
}
</style>

